import { Col, Row } from "antd";
import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import "./style.scss";
import ProfileMenu from "./../../components/profileMenu/index";
import { setTitlePage } from "../../utils/helper";
import { localizeRouteKey } from "../../shared/helpers";
import { ROUTER_PATH } from "../../common/constant";
const Profile = (props: any) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    setTitlePage(t("footer_title_account"));
  }, []);

  return (
    <Row justify="center" align="middle" className="kd-profile-container">
      <Col span={24}>
        <Row className="kd-go-to-home">
          <a
            onClick={() =>
              props.history.push(localizeRouteKey(ROUTER_PATH.HOME))
            }>
            <img
              src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/arrow-tail.svg"
              alt=""
            />
            <span className="sub-content order-detail-bold">
              Quay lại trang chủ
            </span>
          </a>
        </Row>
        <Row justify="center" align="middle">
          <span className="main-title kd-profile-title">MY ACCOUNT</span>
        </Row>

        <Row
          justify="center"
          align="middle"
          className="kd-profile-menu-wrapper">
          <ProfileMenu {...props} />
        </Row>
      </Col>
    </Row>
  );
};
export default withTranslation()(Profile);
